export const SEARCH_TYPE_OPTIONS = [
    { label: 'fieldInventoryDashboard.searchType.sapOrderMyCaseId', code: 'ordernum' },
    { label: 'fieldInventoryDashboard.searchType.setBatch', code: 'setBatch' },
    { label: 'fieldInventoryDashboard.searchType.accountNumberName', code: 'account' },
];
